/* React hooks */
import {useEffect, useRef, useState} from "react";
/* Routing */
import {useParams} from "react-router-dom";
/* Contexts */
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
/* API */
import {
    deleteCustomLine,
    updateBillingInfosForm,
    updateCustomLine
} from "../../../api/admin/billingReq";
import {checkRequiredFields, getErrorListFromValidation, removeErrorList} from "../../../helper/tools";
import Icon from "../../../components/common/Icon";
import DateInput from "../../../components/common/input-layout/DateInput";


export default function FormBillingDetail({ setShowModal, legend, apiCustomLineList, customLineList, apiBillingInfos }) {

    const {auth} = useAuth();
    const token = auth?.token;
    const {id} = useParams();
    const {billingInfos} = useData();
    const [values, setValues] = useState();
    const [tvaHT, setTvaHT] = useState(0);
    const [totalTemplateHT, setTotalTemplateHT] = useState(0);
    const [totalDeceasedHT, setTotalDeceasedHT] = useState(0);
    const [totalHT, setTotalHT] = useState(0);
    const [totalHtWithReducts, setTotalHtWithReducts] = useState(0);
    const [salesReduct, setSalesReduct] = useState(0);
    const [deceasedReduct, setDeceasedReduct] = useState(0);
    const [totalTTC, setTotalTTC] = useState(0);
    const [newLineTotalHt, setNewLineTotalHt] = useState(0);

    const deceasedNumberRef = useRef();
    const deceasedPriceRef = useRef();
    const templateNumberRef = useRef();
    const templatePriceRef = useRef();
    const totalHtRef = useRef();
    const salesReductRef = useRef();
    const deceasedReductRef = useRef();
    const templateReductRef = useRef();
    const newLineNameRef = useRef();
    const newLineQRef = useRef();
    const newLinePRef = useRef();
    const [customLineArray, setCustomLineArray] = useState([]);

    useEffect(() => {
        if (customLineList?.length > 0) {
            const newCustomLineArray = customLineList.map((line) => ({
                id: line.id,
                name: line.name,
                quantity: line.quantity,
                unitPrice: line.unitPrice,
                totalHt: line.quantity * line.unitPrice,
            }));
            setCustomLineArray(newCustomLineArray);
        }
    }, [customLineList]);

    useEffect(() => {
        setValues(billingInfos)
    }, [billingInfos]);

    const onChange = (e) => {
        setValues({...values, date: e.target.value})
    }

    const onChangeCustomLine = (e) => {
        setValues({...values, customLine: {...values.customLine, [e.target.name]: e.target.value}})
        setNewLineTotalHt(newLineQRef.current.value * newLinePRef.current.value)
    }

    const onChangeValue = () => {
        setTotalDeceasedHT(deceasedNumberRef.current.value * deceasedPriceRef.current.value)
        setTotalTemplateHT(templateNumberRef?.current.value * templatePriceRef?.current.value)
        setTotalHT(totalTemplateHT + totalDeceasedHT)
        setSalesReduct(salesReductRef?.current.value / 100 * totalHT)
        setDeceasedReduct(deceasedReductRef?.current.value / 100 * totalDeceasedHT)
        setTotalHtWithReducts(parseFloat(totalHT - salesReduct - deceasedReduct - templateReductRef?.current?.value).toFixed(2))
        setTvaHT(totalHtWithReducts * values?.tvaRate / 100)
        setTotalTTC(totalHtWithReducts + tvaHT)
    }

    const onChangeValueCustomQ = (e, index) => {
        const newQuantity = parseFloat(e.target.value) || 0;
        const updatedList = customLineArray.map((item, i) =>
            i === index
                ? {...item, quantity: newQuantity, totalHt: newQuantity * item.unitPrice}
                : item
        );
        setCustomLineArray(updatedList);
    };

    const onChangeValueCustomP = (e, index) => {
        const newUnitPrice = parseFloat(e.target.value) || 0;
        const updatedList = customLineArray.map((item, i) =>
            i === index
                ? {...item, unitPrice: newUnitPrice, totalHt: item.quantity * newUnitPrice}
                : item
        );
        setCustomLineArray(updatedList);
    };

    useEffect(() => {
        setTotalTemplateHT(templateNumberRef?.current?.value * templatePriceRef?.current?.value)
        setTotalDeceasedHT(deceasedNumberRef.current?.value * deceasedPriceRef.current?.value)
        setTotalHT(totalTemplateHT + totalDeceasedHT + customLineArray.reduce((acc, line) => acc + line.totalHt, 0) + newLineTotalHt)
        setTotalHtWithReducts(totalHT - salesReduct - deceasedReduct - templateReductRef?.current?.value)
        setSalesReduct(salesReductRef?.current.value / 100 * totalHT)
        setDeceasedReduct(deceasedReductRef?.current.value / 100 * totalDeceasedHT)
        setTvaHT(totalHtWithReducts * values?.tvaRate / 100)
        setTotalTTC(totalHtWithReducts + tvaHT)
    }, [
        billingInfos,
        templateNumberRef?.current?.value,
        templatePriceRef?.current?.value,
        customLineArray,
        deceasedNumberRef?.current?.value,
        deceasedPriceRef?.current?.value,
        salesReductRef?.current?.value,
        deceasedReductRef?.current?.value,
        templateReductRef?.current?.value,
        totalHT,
        newLineTotalHt,
        totalHtWithReducts,
        values,
        id
    ])

    const handleValidateNewLine = (e) => {
        e.preventDefault()
        let body = {
            billingId: parseInt(id),
            invoiceNumber: billingInfos?.invoiceNumber,
            customLine: {
                id: 0,
                name: values?.customLine?.name,
                quantity: parseInt(values?.customLine?.quantity),
                unitPrice: (values?.customLine?.unitPrice).replace(',', '.'),
                totalHt: newLineTotalHt.toFixed(2)
            }
        }
        updateCustomLine(token, body)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    newLineNameRef.current.value = '';
                    newLineQRef.current.value = '';
                    newLinePRef.current.value = '';
                    setNewLineTotalHt(0);
                    setValues({...values, customLine: {name: '', quantity: '', unitPrice: ''}})
                    apiBillingInfos();
                    apiCustomLineList();
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: parseInt(id),
            date: values?.date,
            deceasedNumber: parseInt(deceasedNumberRef?.current?.value),
            deceasedPrice: deceasedPriceRef?.current?.value,
            templateNumber: parseInt(templateNumberRef?.current?.value),
            templatePrice: templatePriceRef?.current?.value,
            salesReduct: salesReductRef?.current?.value,
            deceasedReduct: deceasedReductRef?.current?.value,
            templateReduct: templateReductRef?.current?.value,
            totalHtReduct: totalHtWithReducts.toFixed(2),
            totalTtc: totalTTC.toFixed(2),
        }
        await updateBillingInfosForm(token, body, id)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    apiBillingInfos();
                    setShowModal(false)
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    };

    const handleDeleteCustomLine = (lineId) => {
        let body = {
            id: lineId
        }
        deleteCustomLine(token, body)
            .then(response => {
                removeErrorList();
                if(!response?.response?.data?.error) {
                    apiCustomLineList();
                } getErrorListFromValidation(response?.response?.data?.error)
            })
    }

    return (
        <form method='POST' noValidate>
            <fieldset>
                <Icon source="fa fa-file-invoice-dollar" span="Détail d'une facture"/>
                <div className="form-input">
                    <label>Référence contrat</label>
                    <span>{billingInfos?.contractReference}</span>
                </div>
                <div className="form-input">
                    <label>Numéro de facture</label>
                    <span>{billingInfos?.invoiceNumber}</span>
                </div>
                <div className="form-input">
                    <label>Agence</label>
                    <span>{billingInfos?.agencyName} ( {billingInfos?.zipcode} {billingInfos?.city} ) </span>
                </div>
                <div className="form-input">
                    <label>Date</label>
                    <DateInput max="9999-12-31" name="date" defaultValue={values?.date} onChange={onChange}/>
                </div>
                <div className="form-input">
                    <label>Mois de facturation</label>
                    <span>{billingInfos?.month}</span>
                </div>
                <div className="dashboard-facturation dashboard">
                    <table>
                        <thead>
                        <tr>
                            <th>Produits</th>
                            <th>Quantité</th>
                            <th>Tarifs H.T.</th>
                            <th>Total H.T.</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td><span>Solutions Multi Services - (Défunts)</span></td>
                            <td><input ref={deceasedNumberRef} onChange={onChangeValue} type="text"
                                       defaultValue={values?.deceasedNumber}/></td>
                            <td><input ref={deceasedPriceRef} onChange={onChangeValue} type="text"
                                       defaultValue={values?.deceasedPrice}/> €
                            </td>
                            <td><span>{totalDeceasedHT.toFixed(2)} €</span></td>
                        </tr>
                        {(values?.templateNumber > 0) &&
                        <tr>
                            <td>
                                <span>Site Internet</span>
                            </td>
                            <td><input ref={templateNumberRef} type="text" onChange={onChangeValue}
                                       defaultValue={values?.templateNumber}/></td>
                            <td><input type="text" ref={templatePriceRef} onChange={onChangeValue}
                                       defaultValue={values?.templatePrice}/> €
                            </td>
                            <td><span>{totalTemplateHT.toFixed(2)} €</span></td>
                        </tr>
                        }
                        {customLineArray.map((line, index) => (
                            <tr key={index}>
                                <td><span>{line.name}</span></td>
                                <td>
                                    <input id={`${index}`}
                                           type="number"
                                           value={line.quantity}
                                           onChange={(e) => onChangeValueCustomQ(e, index)}
                                    />
                                </td>
                                <td>
                                    <input id={`${index}`}
                                           type="number"
                                           value={line.unitPrice}
                                           onChange={(e) => onChangeValueCustomP(e, index)}
                                    />€
                                </td>
                                <td><span>{line.totalHt.toFixed(2)} €</span></td>
                                <td>
                                    <button onClick={() => handleDeleteCustomLine(line.id)} className="red-button">
                                    <i className="fa fa-trash"/></button>
                                </td>

                            </tr>
                        ))}
                        <tr className="new-line-row">
                            <td><input ref={newLineNameRef} type="text" placeholder="Nouvelle ligne" name="name" onChange={onChangeCustomLine}/></td>
                            <td><input ref={newLineQRef} type="text" name="quantity" onChange={onChangeCustomLine}/></td>
                            <td><input ref={newLinePRef} type="text" name="unitPrice" onChange={onChangeCustomLine}/></td>
                            <td><span>{newLineTotalHt.toFixed(2)} €</span></td>
                            <td>
                                <button className="add-line-button" type="button" onClick={handleValidateNewLine}><i className="fa fa-plus"/><span>Ajouter</span></button>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td colSpan="2"></td>
                            <td>
                                <span><hr/></span>
                            </td>
                            <td>
                                <hr/>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td>
                                <span>Total H.T.</span>
                            </td>
                            <td><span ref={totalHtRef}>{totalHT.toFixed(2)} €</span></td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td>
                                <span className="reduct-label">Remise (<input type="text" ref={deceasedReductRef}
                                                     defaultValue={values?.deceasedReduct} onChange={onChangeValue}/> %)</span>
                            </td>
                            <td>
                                <span>{deceasedReduct.toFixed(2)} €</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td>
                                <span className="reduct-label">Remise commerciale (<input type="text" ref={salesReductRef}
                                                                 defaultValue={values?.salesReduct}
                                                                 onChange={onChangeValue}/> %)</span>
                            </td>
                            <td>
                                <span>{salesReduct.toFixed(2)} €</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td>
                                <span>Remise sur site</span>
                            </td>
                            <td>
                                <input type="text" ref={templateReductRef}
                                       defaultValue={values?.templateReduct?.toFixed(2)} onChange={onChangeValue}/> €
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td>
                                <span>Total avec remise</span>
                            </td>
                            <td>
                                <span
                                    onChange={onChangeValue}>{(totalHT - salesReduct - deceasedReduct - templateReductRef?.current?.value).toFixed(2)} €</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td>
                                <span>T.V.A. (20.00 %)</span>
                            </td>
                            <td>
                                <span>{tvaHT.toFixed(2)} €</span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td><span>Total T.T.C.</span></td>
                            <td><span>{parseFloat(tvaHT + totalHtWithReducts).toFixed(2)} €</span>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
                <div className="errors"></div>
            </fieldset>
            <div className="buttons-container">
                <button className="red-button" onClick={handleRemoveModal}>
                    <i className="fa fa-xmark"></i>
                    <span>Annuler</span>
                </button>
                <button onClick={handleSubmit} className="green-button">
                    <i className="fa fa-check"></i>
                    <span>Enregistrer</span>
                </button>
            </div>
        </form>
    );
}